import { useMemo } from 'react';
import { TCollections } from 'types';
import MediaSlide from 'components/MediaSlide';
import { TPostMedia } from 'types';

type Props = {
  avatar?: string | File;
  collections?: TCollections[];
};

function CollectionsImage({ avatar = '', collections = [] }: Props) {
  const listCollection = useMemo(() => {
    return [{ id: 0, url: avatar }, ...collections];
  }, [avatar, collections]);

  return (
    <div className="w-full">
      <>
        <MediaSlide
          data={
            listCollection.map((item) => {
              return {
                ...item,
                type: `image/${(item?.url as string)?.split('.').pop()}`,
              };
            }) as TPostMedia[]
          }
          showThumbs={true}
        />
      </>
    </div>
  );
}

export default CollectionsImage;
